<template>
  <div id="app">
    <TopNavi />
    <router-view class="container"></router-view>
    <Footer />
  </div>
</template>

<script>
import Footer from "./components/Footer.vue";
import TopNavi from "./components/TopNavi.vue";

export default {
  name: "app",
  components: {
    Footer,
    TopNavi,
  },
  data() {
    return {};
  },
};
</script>
<style>
* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}
body,
#app {
  width: 100%;
  margin: 0px;
}
ul,
li,
ol {
  list-style: none;
  margin: 0;
  padding: 0;
}
::-webkit-scrollbar {
  display: none;
}
.container {
  position: relative;
}
a {
  text-decoration: none;
}
.fontDown1 {
  cursor: default;
  position: absolute;
  color: rgba(255, 255, 255, 1);
  font-family: NanumBarunGothicUltraLightOTF;
  font-size: 20px;
}
.fontDown2 {
  cursor: default;
  position: absolute;
  color: rgba(255, 255, 255, 1);
  font-family: NanumBarunGothicOTF;
  font-size: 20px;
}
.fontDown3 {
  cursor: default;
  position: absolute;
  color: rgba(255, 255, 255, 1);
  font-family: NanumBarunGothicLightOTF;
  font-size: 20px;
}
.fontDown4 {
  cursor: default;
  position: absolute;
  color: rgba(255, 255, 255, 1);
  font-family: NanumBarunGothicBoldOTF;
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue